import { type ClientHint } from '@epic-web/client-hints'

export const innerWidthHint = {
  cookieName: 'CH-window-inner-width',
  getValueCode: 'window.innerWidth',
  fallback: 1280,
} as const satisfies ClientHint<number>
